import { Routes } from '@angular/router';
import { AuthGuard } from './core/services/auth-guard.service';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';


export const rootRouterConfig: Routes = [
  {
    path: "",
    redirectTo: "signin",
    pathMatch: "full",
  },

  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/admin/sessions/sessions.module").then(
            (m) => m.SessionsModule
          ),
        data: { title: "" },
      },
    ],
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./modules/admin/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
        data: { title: "Dashboard", breadcrumb: "Dashboard" },
      },
      {
        path: "package-details",
        loadChildren: () =>
          import("./modules/admin/package-details/package-details.module").then(
            (m) => m.PackagedetailsModule
          ),
        data: { title: "Package Details", breadcrumb: "Package Details" },
      },
      {
        path: "payment-transaction",
        loadChildren: () =>
          import(
            "./modules/admin/payment-transaction/payment-transaction.module"
          ).then((m) => m.PaymenttransactionModule),
        data: {
          title: "Payment Transaction",
          breadcrumb: "Payment Transaction",
        },
      },
      {
        path: "redeem-users",
        loadChildren: () =>
          import("./modules/admin/redeem-users/redeem-users.module").then(
            (m) => m.RedeemusersModule
          ),
        data: { title: "Redeem Users", breadcrumb: "Redeem Users" },
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./modules/admin/settings/settings.module").then(
            (m) => m.AppSettingsModule
          ),
        data: { title: "Master Settings", breadcrumb: "Master Settings" },
      },
      {
        path: "user-management",
        loadChildren: () =>
          import("./modules/admin/user-management/user-management.module").then(
            (m) => m.UsermanageModule
          ),
        data: { title: "User Management", breadcrumb: "User Management" },
      },
      {
        path: "ads-management",
        loadChildren: () =>
          import("./modules/admin/ads-management/ads-management.module").then(
            (m) => m.AdsmanageModule
          ),
        data: { title: "Ads Management", breadcrumb: "Ads Management" },
      },
      {
        path: "wanted-ads",
        loadChildren: () =>
          import("./modules/admin/wanted-ads/wanted-ads.module").then(
            (m) => m.WantedAdsModule
          ),
        data: { title: "Wanted Ads Request", breadcrumb: "Wanted Ads Request" },
      },
      {
        path: "notification-list",
        loadChildren: () =>
          import(
            "./modules/admin/notification-list/notification-list.module"
          ).then((m) => m.NotificationlistModule),
        data: { title: "Notification List", breadcrumb: "Notification List" },
      },
      {
        path: "feedback",
        loadChildren: () =>
          import("./modules/admin/feedback/feedback.module").then(
            (m) => m.FeedbackModule
          ),
        data: { title: "Feedback", breadcrumb: "Feedback" },
      },
      {
        path: "reports",
        loadChildren: () =>
          import("./modules/admin/report/report.module").then(
            (m) => m.ReportModule
          ),
        // data: { title: "Gowtham", breadcrumb: "Ads Report"},
      },

      
    ],
  },
  {
    path: "**",
    redirectTo: "sessions/404",
  },
];
